import { createContext, useContext, useEffect, useRef } from 'react';

/**
 * 多标签页下，页面是否正显示着。
 * 标签切走、或在本标签里点进了详情时，页面不会卸载，轮询类页面用它在隐藏时暂停请求。
 * 不在标签页里渲染（手机端、平台端）时恒为 true。
 */
export const PageTabActiveContext = createContext(true);

export const usePageTabActive = () => useContext(PageTabActiveContext);

/**
 * 页面在本标签里被详情、编辑页盖住后又回到前台的次数。
 * 切换标签不算，那种情况页面原样显示、不重新请求。
 */
export const PageReturnContext = createContext(0);

/**
 * 从详情、编辑页返回这个页面时执行 onReturn，通常是按原来的筛选重新查一次列表，
 * 这样在编辑页改过的数据回来就能看到。
 */
export const useOnPageReturn = (onReturn: () => void) => {
  const returns = useContext(PageReturnContext);
  const ref = useRef(onReturn);
  ref.current = onReturn;
  const seen = useRef(returns);
  useEffect(() => {
    if (returns === seen.current) return;
    seen.current = returns;
    ref.current();
  }, [returns]);
};
